<div class="app-modal">
    <div class="app-modal-box">
        <ng-content></ng-content>
    </div>
</div>